import React from 'react'

import { SxProps } from '@mui/material'
import { TMetricSourceRef, TMetricView } from 'types/GlobalMetric'

import { useMetric } from 'redux/hooks/Metrics'
import { useMetricSegmentAttributeOptions } from 'redux/hooks/AttributeOptions'

import Box from 'components_new/atoms/Box'
import Grid from 'components_new/atoms/Grid'

import ChartElement, { FilterSegmentParams } from './ChartElement'

interface Props {
  metricView?: TMetricView & { title: string; unit: string | null }
  onFilter?: (params: FilterSegmentParams) => void
  source?: TMetricSourceRef
  sx?: SxProps
}

const ChartView = (props: Props) => {
  const { metricView, onFilter, source, sx } = props

  const fullMetric = useMetric(
    metricView?.metric_id,
    metricView?.variant_kpi_template_id
  )

  const segmentOptions = useMetricSegmentAttributeOptions(
    fullMetric?.fact_table_id
  )
  const suggestedOptions = segmentOptions.filter((option) => option.suggested)

  return (
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        gap: 2,
        position: 'relative',
        ...sx
      }}
    >
      <Grid container={true} spacing={2}>
        {metricView &&
          suggestedOptions.map((option) => (
            <Grid xs={6} item={true} key={option.id}>
              <ChartElement
                metricView={metricView}
                onFilter={onFilter}
                option={option}
                source={source}
              />
            </Grid>
          ))}
      </Grid>
    </Box>
  )
}

export default ChartView
